import React from 'react';

import { HintLink } from '../../../../../../HintLink';

export const TelegramLink: React.FC = ({ children }) => (
  <HintLink
    href="https://t.me/ut_personal_manager_bot"
    target="_blank"
    rel="nofollow noopener"
    tabIndex={-1}
  >
    {children}
  </HintLink>
);
